import styled, { css } from "styled-components";
import { Link as RrdLink } from "react-router-dom";

export const Link = styled(RrdLink)`
  color: white;
  text-decoration: none;
  padding: 0px 35px;
  height: 52px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;

  background: rgb(45, 52, 54);

  @media(max-width: 767px){
    height: 45px;
    padding: 0px 12px;
    font-weight: 500;
  }
`